<section class="indecation" id="indecation">
    <div class="indecation__title">
        <h1>Indication uses and doses <span class="ref">(02)</span></h1>
    </div>

    <div class="list">
        <!-- <div  class="indecation__card"> -->
          <table class="list__table" data-aos="fade-up" data-aos-duration="500">
            <tr *ngFor="let indication of indications">
              <td class="ind">
                {{indication.indication}}
              </td>
              <td class="dose">
                <table>
                  <tr *ngFor="let dose of indication.doses">
                      <td class="dose-text">{{dose.criteria}} {{dose.dose}}</td>
                      <!-- <td>{{dose.dose}}</td> -->
                  </tr>
              </table>
              </td>
            </tr>
          </table>
            <!-- <div class="indecation__card__title">
                <h1>
                    {{indication.indication}}
                </h1>
            </div>
            <div class="indecation__card__doses">
                <div class="indecation__card__doses__details">

                    <table>
                        <tr *ngFor="let dose of indication.doses">
                            <td>{{dose.criteria}}</td>
                            <td>{{dose.dose}}</td>
                        </tr>
                    </table>

                </div>

            </div> -->
        <!-- </div> -->
        <!-- <div data-aos="fade-up" data-aos-duration="700" class="indecation__card">
            <div class="indecation__card__title">
                <h1>
                    Fever
                </h1>
            </div>
            <div class="indecation__card__doses">
                <h2>Doses</h2>
                <div class="indecation__card__doses__details">

                    <table>
                        <tr>
                            <td>Adult</td>
                            <td>2 </td>
                            <td>Capsules/day </td>

                        </tr>
                        <tr>
                            <td>children</td>
                            <td>1 </td>
                            <td>Capsules/day </td>

                        </tr>
                    </table>

                </div>

            </div>
        </div>
        <div data-aos="fade-up" data-aos-duration="500" class="indecation__card">
            <div class="indecation__card__title">
                <h1>
                    Fever
                </h1>
            </div>
            <div class="indecation__card__doses">
                <h2>Doses</h2>
                <div class="indecation__card__doses__details">

                    <table>
                        <tr>
                            <td>Adult</td>
                            <td>2 </td>
                            <td>Capsules/day </td>

                        </tr>
                        <tr>
                            <td>children</td>
                            <td>1 </td>
                            <td>Capsules/day </td>

                        </tr>
                    </table>

                </div>

            </div>
        </div> -->
    </div>
</section>
